module.exports = __webpack_public_path__ + "static/img/xbzj.14c6136.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xbzj.png
// module id = QmHi
// module chunks = 1